import React from 'react';
import ProductCommitted from 'components/Tvendo/Sale/Operations/ProductCommitted/List.js';

export default function () {
  return <ProductCommitted />;
}
